<template lang="pug">
v-container(fluid, tag="div")
  v-row
    v-col(cols="12", md="6")
      v-card
        v-card-title Online Demo
        v-card-text
          v-form(ref="form", v-model="valid", lazy-validation)
            v-text-field.mb-2(
              v-model="name",
              :rules="[(v) => !!v || 'Full name is required']",
              label="Full name",
              required
            )
            v-text-field.mb-2(
              type="number",
              v-model="idNumber",
              :rules="[(v) => !!v || 'ID Number is required']",
              label="ID Number",
              required
            )
            v-text-field.mb-2(
              v-model="email",
              :rules="emailRules",
              label="E-mail",
              required
            )
            v-text-field.mb-2(
              type="number",
              v-model="phoneNumber",
              label="Phone Number"
            )
            v-text-field.mb-2(
              v-model="callUrl",
              label="Callback URL",
              required
            )
            v-text-field.mb-2(v-model="backUrl", label="Backend URL", required)
            v-file-input(
              show-size,
              :rules="rules",
              accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf",
              placeholder="Pick a document file",
              prepend-icon="mdi-file",
              label="Document File",
              v-model="documentFile"
            )
        v-card-actions
          v-spacer
          v-btn(color="blue darken-1", text, @click="reset") Reset
          v-btn(color="blue darken-1", text, @click="submit") Submit
      v-card(v-if="loading")
        i.fas.fa-spin.fa-spinner.fa-5x.mx-auto(v-if="loading")
      v-card(v-else-if="result")
        v-card-title Result
        v-card-text
          a(:href="result" target="_blank") Click to Sign.
    v-col(cols="12", md="6")
      v-card
        v-card-title API Integration
        v-card-text
          h5.text-info Request Body
          pre.mb-4 {{ JSON.stringify(exampleRequest, null, 2) }}
          h5.text-danger Response Body
          pre.mb-4 {{ JSON.stringify(exampleResponse, null, 2) }}
</template>

<script>
export default {
  data() {
    return {
      rules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          "Avatar size should be less than 5 MB!",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      valid: false,
      name: "",
      idNumber: "",
      email: "",
      phoneNumber: "",
      documentFile: null,
      callUrl: "",
      backUrl: "",
      exampleRequest:
        "{username: 'YOUR_USERNAME', auth_key: 'YOUR AUTH_KEY', name: 'FULL NAME ON IC', 'idNumber': 'IC NUMBER', 'email': 'EMAIL ADDRESS', 'phoneNumber': 'PHONE NUMBER', 'documentFile': 'FILE OBJECT', 'callUrl': 'CALLBACK URL', 'backUrl': 'WEBHOOK URL' }",
      exampleResponse: "{'success': true/false, 'data': 'SIGNING_URL' }",
      result: null,
      loading: false,
    };
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;

      const url = "https://saas-api.xendity.com/v1/webservice/upload";

      var now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      var string =
        this.$store.getters.authKey +
        this.$store.getters.apiKey +
        this.$store.getters.userName +
        this.$store.getters.apiKey +
        now;

      var string1 = this.CryptoJS.enc.Utf8.parse(this.CryptoJS.MD5(string));
      var signature = this.CryptoJS.enc.Base64.stringify(string1);

      var formData = new FormData();
      formData.append("username", this.$store.getters.userName);
      formData.append("auth_key", this.$store.getters.authKey);
      formData.append("name", this.name);
      formData.append("idNumber", this.idNumber);
      formData.append("email", this.email);
      formData.append("phoneNumber", this.phoneNumber);
      formData.append("documentFile", this.documentFile);
      formData.append("callUrl", this.callUrl);
      formData.append("backUrl", this.backUrl);
      formData.append("signature", signature);
      formData.append("request_time", now);

      // const json = {
      //   username: this.$store.getters.userName,
      //   auth_key: this.$store.getters.authKey,
      //   name: this.name,
      //   idNumber: this.idNumber,
      //   email: this.email,
      //   phoneNumber: this.phoneNumber,
      //   documentFile: this.documentFile,
      //   callUrl: this.callUrl,
      //   backUrl: this.backUrl,
      // };

      this.loading = true;

      this.$http
        .post(url, formData)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal("Upload error", response.body.data.message, "error");
              else this.result = response.body.data;
            }
          } catch (error) {
            this.$swal("Upload error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Upload error", response.body.data.message, "error");
        });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>